import { EventStreamMarshaller } from "./EventStreamMarshaller";
/** browser event stream serde utils provider */
export var eventStreamSerdeProvider = function eventStreamSerdeProvider(options) {
  return new EventStreamMarshaller(options);
};